import { maybe } from '@passionware/monads';
import { ReactNode } from 'react';
import { DialogHeader, DialogTitle } from 'v5/design-system/Dialog';
import { Tabs, TabsList, TabsTrigger } from 'v5/design-system/Tabs';

export type Tab = 'estimate' | 'actual';
export interface BookingCostsHeaderProps {
  title: ReactNode;
  estimateTotal: ReactNode;
  actualTotal: ReactNode;
  tab: Tab;
  onTabChange: (tab: Tab) => void;
  actualTabName: ReactNode;
}

export const BookingCostsHeader = ({
  title,
  estimateTotal,
  actualTotal,
  tab,
  onTabChange,
  actualTabName
}: BookingCostsHeaderProps) => {
  return (
    <DialogHeader>
      <DialogTitle className="flex items-center gap-2 py-2">
        <div>{title}</div>
        <Tabs value={tab} onValueChange={tab => onTabChange(tab as Tab)}>
          <TabsList className="self-start">
            <TabsTrigger value="estimate">
              Estimated {maybe.map(estimateTotal, total => `(${total})`)}
            </TabsTrigger>
            <TabsTrigger value="actual">
              {actualTabName} {maybe.map(actualTotal, total => `(${total})`)}
            </TabsTrigger>
          </TabsList>
        </Tabs>
      </DialogTitle>
    </DialogHeader>
  );
};
